<template>
  <div
    class="
      group
      absolute
      translate-x-[-50%] translate-y-[-50%]
      hover:z-50
      cursor-pointer
      duration-300
      hover:scale-[1.3]
      transition-all
      active:scale-[1.5]
    "
    :class="{ 'z-50 scale-[1.3]': shouldhover, 'scale-[1.3]': selected }"
    :style="{
      top: position.y + 'px',
      left: position.x + 'px',
      height: spacing / 1.3 + 'px',
      width: spacing / 1.3 + 'px',
      fontSize: spacing / 5 + 'px'
    }"
  >
    <div
      :style="{
        left: spacing / 1.3 + 'px'
      }"
      class="
        group-hover:block group-hover:pointer-events-auto
        rounded-box
        w-64
        ml-2
        transition-all
        group-hover:animate-animated group-hover:animate-fadeInRight
        absolute
        hidden
        pointer-events-none
        z-[100]
        bg-base-200
        text-base-content
        p-2
        left-0
        top-[50%]
        translate-y-[-50%]
        ring-2
      "
      :class="{
        '!block animate-animated animate-rotateIn': shouldhover,
        'ring-secondary': item.type.id == 1,
        'ring-secondary': item.type.id == 2,
        'ring-secondary': item.type.id == 3
      }"
    >
      <span
        class="text-sm font-bold text-secondary"
        :class="{
          'text-secondary': item.type.id == 1,
          'text-secondary': item.type.id == 2,
          'text-secondary': item.type.id == 3
        }"
      >
        {{ item.name }}
      </span>
      <div class="text-sm">
        Abbreviation : <span class="font-bold">{{ item.abbreviation }}</span>
      </div>
      <div class="text-sm">
        Role : <span class="font-bold">{{ item.role }}</span>
      </div>
      <div class="text-sm">
        Type d'acteur : <span class="font-bold">{{ item.type.value }}</span>
      </div>
      <div class="text-sm">
        Influence de l'acteur :
        <span class="font-bold">{{ item.influence.value }}</span>
      </div>
      <div class="text-sm">
        Implication de l'acteur :
        <span class="font-bold">{{ item.implication.value }}</span>
      </div>

      <div class="hidden mt-4 text-xs italic">
        Cliquez pour modifier la categorie de cet acteur
      </div>
    </div>
    <div
      :style="{
        paddingBottom: spacing / 5 + 'px'
      }"
      :class="{
        'bg-1-non-institutionelle text-primary-content group-hover:bg-secondary-focus':
          item.type.id == 1,
        '!bg-neutral !shadow-2xl animate-animated animate-headShake animate-infinite': selected,
        'bg-2-institutionelle text-accent-content group-hover:bg-secondary-focus':
          item.type.id == 2,
        'bg-3-financier text-secondary-content group-hover:bg-secondary-focus':
          item.type.id == 3
      }"
      class="absolute flex items-end justify-center w-full h-full p-1 overflow-hidden font-bold uppercase transform rounded-full animate-animated animate-zoomIn ring-2 ring-base-100 animate-duration-300"
    >
      {{
        item.abbreviation
          .split("")
          .slice(0, 3)
          .join("")
      }}
      <small>{{ item.abbreviation.split("").length > 3 ? "..." : "" }}</small>
    </div>

    <div
      class="absolute right-0 flex justify-center text-xl font-bold rounded-full animate-animated animate-fadeInUp animate-delay-1s -top-2 ring-2 ring-base-100 text-base-100"
      :style="{
        height: spacing / 3 + 'px',
        width: spacing / 2.5 + 'px'
      }"
      :class="{
        'bg-1-engage': item.implication.id == 1,
        'bg-2-peu-engage': item.implication.id == 2,
        'bg-3-indecis': item.implication.id == 3
      }"
    >
      {{ implications.symbol[item.implication.id - 1] }}
    </div>
  </div>
</template>

<script>
export default {
  name: "APPBullet",
  props: {
    item: Object,
    spacing: Number,
    position: Object,
    shouldhover: Boolean,
    selected: Boolean
  },
  data() {
    return {
      implications: {
        symbol: ["+", "-", "!"]
      }
    };
  }
};
</script>

<style></style>
